var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n    font-family: Cabin;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    src: url(" + escape(require("./cabin-v14-latin-regular.woff2")) + ") format(\"woff2\"), url(" + escape(require("./cabin-v14-latin-regular.woff")) + ") format(\"woff\");\r\n    font-display: swap;\r\n  }\r\n", ""]);

// exports
